import { vueApp } from "../Common/vueApp";
import ScoreboardOverviewApp from "./LiveScoreboardsApp.vue";

export default vueApp(ScoreboardOverviewApp);
